<template>
  <div class="modal fade" :id="id" tabindex="-1" role="dialog" :class="modalClass">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ modalTitle }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="resetForm">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">

          <div v-if="loading" class="text-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
            <p class="mt-2">Procesando archivo...</p>
          </div>

          <form v-if="!loading && !successMessage && !errorMessage" @submit.prevent="submitForm">
            <div class="alert alert-info" role="alert">
              <strong>Formato del CSV requerido:</strong>
              <p class="mb-1 mt-2">El archivo debe contener las siguientes cabeceras:</p>
              <ul class="mb-0">
                <li><code>CONTRACTID</code> - ID del contrato</li>
                <li><code>CUOTA</code> - Número de cuota</li>
                <li><code>ESTADO</code> - Estado del pago</li>
                <li><code>FECHAPAGO</code> - Fecha de pago</li>
              </ul>
            </div>

            <div class="form-group">
              <label for="paymentCsvFile">Adjuntar CSV de pagos de remesas:</label>
              <input
                type="file"
                class="form-control"
                id="paymentCsvFile"
                accept=".csv"
                @change="handleFileUpload"
                required
              >
              <small v-if="fileSizeError" class="text-danger">El archivo es demasiado grande. Máximo 5MB.</small>
              <small v-if="fileTypeError" class="text-danger">Por favor, selecciona un archivo CSV válido.</small>
            </div>
            <div class="d-flex justify-content-end">
              <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal" @click="resetForm">
                Cancelar
              </button>
              <button type="submit" class="btn btn-primary" :disabled="!csvFile || fileSizeError || fileTypeError">
                CARGAR CSV
              </button>
            </div>
          </form>

          <div v-if="successMessage" class="text-center">
            <div class="alert alert-success">
              {{ successMessage }}
            </div>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="resetForm">
              Cerrar
            </button>
          </div>

          <div v-if="errorMessage" class="text-center">
            <div class="alert alert-danger">
              {{ errorMessage }}
            </div>
            <button type="button" class="btn btn-secondary" @click="resetForm">
              Intentar de nuevo
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalUploadPaymentCSV',
  props: {
    id: String,
    modalTitle: String,
    modalClass: String
  },
  data() {
    return {
      csvFile: null,
      fileSizeError: false,
      fileTypeError: false,
      loading: false,
      successMessage: '',
      errorMessage: ''
    };
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];

      // Validar tipo de archivo
      if (file && !file.name.toLowerCase().endsWith('.csv')) {
        this.fileTypeError = true;
        this.fileSizeError = false;
        this.csvFile = null;
        return;
      }

      // Validar tamaño (5MB max)
      if (file && file.size > 5 * 1024 * 1024) {
        this.fileSizeError = true;
        this.fileTypeError = false;
        this.csvFile = null;
      } else {
        this.csvFile = file;
        this.fileSizeError = false;
        this.fileTypeError = false;
      }
    },
    submitForm() {
      if (this.csvFile && !this.fileSizeError && !this.fileTypeError) {
        this.loading = true;
        const formData = new FormData();
        formData.append('csv', this.csvFile);

        this.$emit('submitForm', { formData });
      }
    },
    closeModal() {
      this.resetForm();
      this.$emit('close');
    },
    resetForm() {
      this.csvFile = null;
      this.fileSizeError = false;
      this.fileTypeError = false;
      this.loading = false;
      this.successMessage = '';
      this.errorMessage = '';
      // Limpiar el input file
      const fileInput = document.getElementById('paymentCsvFile');
      if (fileInput) {
        fileInput.value = '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.spinner-border {
  width: 2rem;
  height: 2rem;
  border-width: 0.25rem;
  color: #cc0b7a;
}

.btn-primary {
  background-color: #cc0b7a;
  border-color: #cc0b7a;
}

.btn-primary:hover {
  background-color: #a30962;
  border-color: #a30962;
}

.btn-primary:disabled {
  background-color: #e085b3;
  border-color: #e085b3;
}

.modal-content {
  padding: 15px;
}

code {
  background-color: #f8f9fa;
  padding: 2px 6px;
  border-radius: 3px;
  color: #cc0b7a;
}
</style>
